import React from 'react';
export default function Loading({
  text,
  loadingClass,
  textClass,
}: {
  text: string;
  loadingClass?: string;
  textClass?: string;
}) {
  return (
    <div className='flex flex-col justify-center items-center h-full'>
      <img src='/loading.gif' alt='Loading' className={`${loadingClass ?? ''}`} />
      <h4 className={`${textClass ?? ''}`}>{text}</h4>
    </div>
  );
}
